/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_TitleInputs */

const en_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobs`)
};

const de_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen`)
};

const fr_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplois`)
};

const es_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleos`)
};

const it_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavori`)
};

const nl_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banen`)
};

const pl_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty pracy`)
};

const fi_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikat`)
};

const da_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const sv_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb`)
};

/**
* | output |
* | --- |
* | "Jobs" |
*
* @param {Jobs_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_title = /** @type {((inputs?: Jobs_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_title(inputs)
	if (locale === "fr") return fr_jobs_title(inputs)
	if (locale === "es") return es_jobs_title(inputs)
	if (locale === "it") return it_jobs_title(inputs)
	if (locale === "nl") return nl_jobs_title(inputs)
	if (locale === "pl") return pl_jobs_title(inputs)
	if (locale === "fi") return fi_jobs_title(inputs)
	if (locale === "da") return da_jobs_title(inputs)
	if (locale === "sv") return sv_jobs_title(inputs)
	return en_jobs_title(inputs)
});